import { Component, Input } from '@angular/core';

import * as Models from 'appshared/shared-models';

@Component({
	selector: 'app-paging-bar',
	templateUrl: './paging-bar.component.html',
	styleUrls: []
})
export class PagingBarComponent {
	@Input() parentApi !: any;
	@Input() pagingOptions: Models.TablePagingOptions = null;
	@Input() pageNum: number = 0;
	@Input() uniqueId: string = '';
	@Input() centered: boolean = true;

	// ------------------------------------------------------------------------
	constructor() { }

	// ------------------------------------------------------------------------
	setPageNum(pageNum: number) {
		if (this.parentApi) this.parentApi.setPageNum(pageNum, this.uniqueId);
	} // setPageNum
}
